import type { TourDefinition } from "../types";

export const inspectionsTour: TourDefinition = {
  id: "inspections",
  titleKey: "onboarding.tours.inspections.title",
  descriptionKey: "onboarding.tours.inspections.description",
  module: "inspections",
  estimatedMinutes: 2,
  steps: [
    {
      id: "inspections-intro",
      targetSelector: "[data-tour='search-input']",
      titleKey: "onboarding.tours.inspections.intro.title",
      descriptionKey: "onboarding.tours.inspections.intro.description",
      placement: "bottom",
      navigateTo: "/inspections",
      waitForSelector: "[data-tour='search-input']",
    },
    {
      id: "inspections-add",
      targetSelector: "[data-tour='create-button']",
      titleKey: "onboarding.tours.inspections.add.title",
      descriptionKey: "onboarding.tours.inspections.add.description",
      placement: "bottom",
      action: "click",
      actionTarget: "[aria-label='Add Inspection']",
      highlightPulse: true,
    },
    {
      id: "inspections-template",
      targetSelector: "[role='dialog']",
      titleKey: "onboarding.tours.inspections.template.title",
      descriptionKey: "onboarding.tours.inspections.template.description",
      placement: "right",
      waitForSelector: "[role='dialog']",
    },
    {
      id: "inspections-save",
      targetSelector: "[role='dialog'] button[type='submit']",
      titleKey: "onboarding.tours.inspections.save.title",
      descriptionKey: "onboarding.tours.inspections.save.description",
      placement: "top",
      celebration: "checkmark",
    },
  ],
};
